import axios from 'axios';
import dotenv from 'dotenv';
dotenv.config();

const token = localStorage.getItem('user-token');

function buildHeadersLifeAPI() {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

function buildURLLifeAPI(controller, action) {
  const url = process.env.VUE_APP_API_VIDA_URL + '/' + controller.toLowerCase();
  if (action) {
    return url + '/' + action;
  }
  return url;
}

export default {
  async getLifePolicy(apoliceId, contractPdfLog) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/life/${apoliceId}?contractPdfLog=${contractPdfLog}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_API_VIDA_TOKEN}`,
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  getAll(controller, action = '') {
    const url = buildURLLifeAPI(controller, action);
    const headers = buildHeadersLifeAPI();
    return axios.get(url, headers);
  },

  post(controller, body, action = '') {
    const url = buildURLLifeAPI(controller, action);
    const headers = buildHeadersLifeAPI();
    return axios.post(url, body, headers);
  },

  update(controller, body, action = '') {
    const url = buildURLLifeAPI(controller, action);
    const headers = buildHeadersLifeAPI();
    return axios.patch(url, body, headers);
  },

  async refuseProposalAdmin(id, reasonId, description) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/life/${id}/refuse`,
        {
          reasonId,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async confirmRefund(id, refundDate, refundValue) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/life/${id}/confirm-refund`,
        {
          refundDate,
          refundValue,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getStipulators() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/stipulator`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async activateLifePolicy(policyId) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/life/policy/${policyId}/activate`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
